import React from "react";
import paths from "@icarius-router/paths";
import ScreenSelector from "@icarius-common/screenSelector";
import {
  TurnDefinitionIcon,
  ScheduleDefinitionIcon,
  SchedulesProgrammingIcon,
  CalendarDefinitionIcon,
  ExtraHoursTableIcon,
  TotemsIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const TimeDefinition = () => {

  const data = [
    {
      name: getLocalizedString("calendarDefinition"),
      icon: <CalendarDefinitionIcon />,
      path: paths.calendarDefinition,
    },
    {
      name: getLocalizedString("turnDefinition"),
      icon: <TurnDefinitionIcon />,
      path: paths.turnDefinition,
    },
    {
      name: getLocalizedString("schedulesDefinition"),
      icon: <ScheduleDefinitionIcon />,
      path: paths.schedulesDefinition,
    },
    {
      name: getLocalizedString("schedulesProgramming"),
      icon: <SchedulesProgrammingIcon />,
      path: paths.schedulesProgramming,
    },
    {
      name: getLocalizedString("overtimeTypesDefinition"),
      icon: <ExtraHoursTableIcon />,
      path: paths.extraHoursTable,
    },
    {
      name: getLocalizedString("totemManagement"),
      icon: <TotemsIcon />,
      path: paths.totems,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("timeDefinition")}
      data={data}
    />
  );
}

export default TimeDefinition;